/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable */
import React from 'react';
import { Button, Input, Modal, Spin,message } from 'antd';

import ReactResizeDetector from 'react-resize-detector';
import {useNavigate, useParams} from 'react-router-dom';

import leftTest from '../../../../../../assets/2025/topicQuiz/left_test.png';
import {useStore, IQuizOption, IQuizResult} from '../../../../store';
import FinalQuiz from '../../components/FinalQuiz';
import TopicContainer from '../../components/TopicContainer';
import TopicItem from '../../components/TopicItem';

import ImgNotPass from '../../../../../../assets/2025/topicQuiz/not_pass.png';
import ImgPass from '../../../../../../assets/2025/topicQuiz/pass.png';

import { Document, Image, Page, pdf } from '@react-pdf/renderer';

import './index.less';
import './index.en.less';
import QuizReview from '../../components/QuizReview';
import { useGA4React } from 'ga-4-react';
import { LoadingOutlined } from '@ant-design/icons';
import html2canvas from 'html2canvas';
import { saveAs } from 'file-saver';
import {
  finishTrainingApi,
  finishTrainingMoreDataApi,
  generateVerificationCode,
  sendEmail,
  pathToName,
  formatDate,
  formatTime,
} from '../../../../../../api/quiz';

interface IQuizTopicProps {
  settings: any;
}

const QuizTopic: React.FunctionComponent<IQuizTopicProps> = ({ settings }) => {
  const param = useParams();
  const navigate = useNavigate();
  const p_course = param.course || '';
  const p_topic = 'quiz';
  const { updateParagraphState } = useStore();
  const {
    getQuizState,
    setQuizAnswer,
    reQuiz,
    getCourseState,
    setCourseState,
    language,
  } = useStore();
  let quizResult = getQuizState(p_course);
  const [state, setState] = React.useState<{
    inQuiz: boolean;
    containerWidth: number;
    current: number;
    diableScroll: boolean;
    loadingCert: boolean;
    name: string;
    email: string;
    date: string;
    reviewlist: IQuizResult[];
    isNameEditable: boolean;
    code:string;
  }>({
    inQuiz: false,
    containerWidth: 0,
    current: 1,
    diableScroll: false,
    loadingCert: false,
    name: '',
    email: '',
    date: '',
    reviewlist: [],
    isNameEditable: true,
    code:generateVerificationCode()
  });
  const [trainingId, setTrainingId] = React.useState('');
  const onResize = (w: any) => {
    setState({
      ...state,
      inQuiz: false,
      containerWidth: w,
    });
  };
  const next = () => {
    setState({
      ...state,
      current: state.current + 1,
      diableScroll: state.current + 1 > quizResult.results?.length,
      // date: quizResult.datetime?.toLocaleDateString() || '',
      date: formatDate(),
    });
    document?.querySelector('.final-quiz-container')?.scrollTo({
      top: 0,
      left: 0,
    });
  };
  const prev = () => {
    setState({
      ...state,
      current: state.current - 1,
    });
    document?.querySelector('.final-quiz-container')?.scrollTo({
      top: 0,
      left: 0,
    });
  };
  const onStart  = async () => {
    updateParagraphState(p_course, p_topic, '1', 'completed', []);
    setTimeout(() => {
      document
        .querySelectorAll('[data-paragraph]')[1]
        ?.scrollIntoView({ behavior: 'smooth' });
    }, 20);
  };
  const topic2 = settings?.paragraphs?.[1];
  const answer = settings?.answer;
  const finishTraining = async () => {
    let retryAttempts = 0;
    let success = false;

    while (!success && retryAttempts < 2) {
      setState({
        ...state,
        code:generateVerificationCode()
      })
      try {
        await finishTrainingApi({ id: trainingId});
        success = true;
      } catch (error) {
        console.log('Finish training failed, retrying...');
        retryAttempts++;
        await new Promise((resolve) => setTimeout(resolve, 1000));
      }
    }

    if (!success) {
      console.log('Finish training failed after multiple retries');
    }
  };
  React.useEffect(() => {
    setTrainingId('01')
    if (state.current > quizResult.results?.length && quizResult.isPassed) {
      updateParagraphState(p_course, p_topic, '2', 'completed', []);
      setTimeout(() => {
        setState({
          ...state,
          loadingCert: true,
          reviewlist: quizResult?.results
            .map((itm, idx) => ({
              ...itm,
              quizIndex: idx + 1,
            }))
            .filter((itm) => !itm.answer.isCorrect),
        });
        const courseState = getCourseState(p_course);
        setCourseState(p_course, {
          ...courseState,
          progress: courseState.progress + 20,
          step: courseState.step + 1,
        });
      }, 500);
    }
    if(state.current == quizResult.results?.length && quizResult.isPassed){
      finishTraining();
    }
  }, [state.current, quizResult.isPassed]);
  const restest = () => {
    quizResult = reQuiz(p_course);
    setState({
      ...state,
      current: 1,
      diableScroll: true,
    });
    setTimeout(() => {
      setState({
        ...state,
        current: 1,
        diableScroll: false,
      });
    }, 500);
  };
  const ga = useGA4React();
  const addGaEvent = (name: string) => {
    if (ga) {
      ga.gtag('event', 'download', { name });
    }
  };

  const [downLoading, setDownloading] = React.useState(false);
  const { name, email, isNameEditable } = state;
  const downloadPdf = async (div: Element, filename: string) => {
    try {
      const canvas = await html2canvas(div as HTMLElement, { scale: 5 });
      const imgData = canvas.toDataURL('image/png');
      const blob = await pdf(
        <Document>
          <Page orientation="landscape" style={{ padding: 0 }}>
            <Image src={imgData} style={{ width: '100%', height: '100%' }} />
          </Page>
        </Document>
      ).toBlob();
      saveAs(blob, filename);
      setsSendEmail(blob, filename);
    } catch (error) {
      console.error(error);
    }
  };
  const setsSendEmail = (blob: BlobPart, filename: string) => {
    const file = new File([blob], filename, {
      type: 'application/pdf',
    });
    const formData = new FormData();
    const type = pathToName(p_course) || '';
    const now = new Date();
    const day = String(now.getDate()).padStart(2, '0');
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const year = now.getFullYear();
    formData.append('file', file);
    formData.append('name', state.name);
    formData.append('code', state.code);
    formData.append('type', type);
    console.log(formData, state.name);
    sendEmail(formData);
    finishTrainingMoreDataApi({
      name: state.name,
      type,
      email: state.email,
      certificateNumber: state.code,
      date: `${day}/${month}/${year}`,
      time: formatTime(now),
    });
  };
  const handleSaveName = () => {
    if(name.length === 0){
      return message.warning(topic2?.noValueMsg);
    }
    if(email.trim().length === 0){
      return message.warning(topic2?.pass?.noEmailMsg || 'Please enter your email address');
    }
    const emailReg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if(!emailReg.test(email.trim())){
      return message.warning(topic2?.pass?.invalidEmailMsg || 'Please enter a valid email address');
    }
    Modal.confirm({
        title: topic2?.confirm?.title,
        content: isNameEditable ? topic2?.confirm?.content : '',
        onOk: () => {
          setDownloading(true);
          downloadPdf(
            document.getElementsByClassName('cert-container')[0],
            `HKirc-Cybersec-Training-Certification-${p_course}.pdf`
          ).then(() => {
            setDownloading(false);
          });
          setState({ ...state, isNameEditable: false });
        },
      }
    );
  };
  return (
    <TopicContainer className="quiz">
      <TopicItem className="course-landing intro" id="1">
        <div className="course-landing-content ">
          <div className="quiz-test ">
            <img src={leftTest} alt="" />
          </div>
          <div className="quiz-text course-landing-text">
            <div className="title">{settings?.message}</div>
            <div className="subtitle">{settings?.subtitle}</div>
            <div
              className="description"
              dangerouslySetInnerHTML={{ __html: settings?.description }}
            />
            <div className="quiz-btn" onClick={onStart}>
              {settings?.startBtn}
            </div>
          </div>
        </div>
      </TopicItem>
      <TopicItem
        className={`answer ${
          quizResult.isPassed && state.current > 10 ? 'is-pass' : ''
        }`}
        id="2"
      >
        <div key={quizResult.quizId} className="progress">
          <div
            key={state.current}
            style={{
              width: `${
                (state.current > quizResult.results?.length
                  ? 1
                  : state.current / quizResult.results?.length) * 100
              }%`,
            }}
            className="progress-line"
          />
        </div>
        <div
          className={`answer-list ${
            quizResult.isPassed && state.current > 10 ? 'answer-list-pass' : ''
          }`}
        >
          {state?.current <= quizResult.results?.length ? (
            <ReactResizeDetector onResize={onResize}>
              <div className="final-quiz-container">
                <div
                  className="final-quiz-body"
                  style={{
                    width:
                      state.containerWidth * (quizResult.results?.length + 1),
                    left: -(state.current - 1) * state.containerWidth,
                    transition: state.diableScroll
                      ? 'all 0s linear 0s'
                      : 'all 500ms linear 0s',
                  }}
                >
                  {quizResult.results?.map((quiz: any, index: any) => (
                    <div
                      key={quizResult.quizId + index}
                      style={{
                        width:
                          state.containerWidth === 0
                            ? '100%'
                            : `${state.containerWidth}px`,
                      }}
                    >
                      <FinalQuiz
                        quizIndex={index + 1}
                        quizCount={quizResult.results?.length}
                        answer={answer}
                        // description={quiz.description}
                        question={quiz.question}
                        options={quiz.options}
                        onNext={next}
                        onPrev={prev}
                        onSubmit={(selected) => {
                          setQuizAnswer(
                            p_course,
                            quizResult.quizId,
                            quiz.id,
                            selected as IQuizOption
                          );
                        }}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </ReactResizeDetector>
          ) : (
            <div className="quiz-result">
              {quizResult.isPassed ? (
                <>
                  <div className="quiz-result-pass">
                    <div className="left">
                      <img src={ImgPass} alt="" />
                    </div>
                    <div className="right">
                      <div className="quiz-result-title">
                        <h3>{topic2?.pass?.text}</h3>
                        <div className="tips">
                          <a
                            href="https://forms.office.com/r/cmhxnU3zQy"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <span>{topic2?.pass?.l1}</span>
                          </a>
                          <p>{topic2?.pass?.l2}</p>
                          <p>{topic2?.pass?.l3}</p>
                        </div>
                      </div>
                      <div className="cert-download-input">
                        <Input
                          className="cert-email-input"
                          placeholder={
                            topic2?.pass?.emailPlaceholder
                          }
                          value={state.email}
                          onChange={(e) => {
                            setState({
                              ...state,
                              email: (e.target as HTMLInputElement).value,
                            });
                          }}
                          disabled={!isNameEditable}
                        />
                        <Input
                          className="cert-name-input"
                          placeholder={topic2?.pass?.placeholder}
                          value={state.name}
                          onChange={(e) => {
                            setState({
                              ...state,
                              name: (e.target as HTMLInputElement).value,
                            });
                          }}
                          disabled={!isNameEditable}
                        />
                        <Button
                          className="cert-download-button"
                          type="link"
                          onClick={handleSaveName}
                        >
                          {downLoading ? (
                            <Spin
                              indicator={
                                <LoadingOutlined
                                  style={{ fontSize: 22, color: 'black' }}
                                  spin
                                />
                              }
                            />
                          ) : (
                            <span>{topic2?.pass?.download}</span>
                          )}
                        </Button>
                      </div>
                      <div className="cert-area">
                        {state.loadingCert &&
                          quizResult.isPassed &&
                          state.current > quizResult.results.length && (
                            <div className="cert-container">
                              <img
                                className="cert-bg"
                                src={
                                  require(`./cert-${process.env.REACT_APP_DOMAIN}.jpg`)
                                    .default
                                }
                                alt=""
                              />
                              <div className="cert-username">
                                {state.email
                                  ? `${state.name} (${state.email})`
                                  : state.name}
                              </div>
                              <div className="cert-adate">{state.date}</div>
                              <div className="cert-code">{state.code}</div>
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                  {state.reviewlist.length <= 0 ? null : (
                    <div className="quiz-review-section">
                      <div className="quiz-result-title">
                        {topic2?.error?.text}
                      </div>
                      <p className="content">
                        {topic2?.error?.l1} {state.reviewlist.length}{' '}
                        {topic2?.error?.l2}
                      </p>
                      {state.reviewlist.map((itm, idx) => (
                        <QuizReview
                          key={idx}
                          language={language}
                          question={itm.question}
                          options={itm.options}
                          quizIndex={itm.quizIndex || 0}
                          answer={itm.answer}
                          topic2={topic2}
                        />
                      ))}
                    </div>
                  )}
                  <div className="nextTopic_box">
                    <Button
                      className="next-topic-button"
                      type="text"
                      onClick={() => navigate(`/`)}
                    >
                      <div className="l1">{topic2?.back}</div>
                    </Button>
                  </div>
                </>
              ) : (
                <div className="quiz-result-not-pass">
                  <div className="left">
                    <img src={ImgNotPass} alt="" />
                  </div>
                  <div className="right">
                    <div className="quiz-result-title">
                      <span>{topic2?.noPass?.text}</span>
                      <h3>
                        {quizResult?.score} <span>{topic2?.noPass?.l4}</span>
                      </h3>
                    </div>
                    <p className="description">
                      {topic2?.noPass?.l1}
                      <br />
                      {topic2?.noPass?.l2}
                      <br />
                      {topic2?.noPass?.l3}
                    </p>
                    <Button
                      onClick={restest}
                      className="quiz-retry-button"
                      type="link"
                    >
                      <span>{topic2?.noPass?.test}</span>
                    </Button>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </TopicItem>
    </TopicContainer>
  );
};

export default QuizTopic;
